/** API and field mapping for supplementary-item attachment popups. */
export const ATTACHMENT_ENTITY_TYPES = {
    PAYABLE_INVOICE: 'PAYABLE_INVOICE',
    MONEY_CODE: 'MONEY_CODE',
    INSPECTION: 'INSPECTION',
    CITATION: 'CITATION',
};

export const ATTACHMENT_ENTITY_CONFIG = {
    [ATTACHMENT_ENTITY_TYPES.PAYABLE_INVOICE]: {
        popupKind: 'payableInvoiceAttachments',
        titlePrefix: 'Attachments — Invoice',
        filesField: 'files',
        uploadFileType: 'Payable Invoice',
        getFileUrl: 'invoices/getFile',
        addFileUrl: 'invoices/addFile',
        removeFileUrl: 'invoices/removeFile',
        entityIdParam: 'invoiceId',
    },
    [ATTACHMENT_ENTITY_TYPES.MONEY_CODE]: {
        popupKind: 'moneyCodeAttachments',
        titlePrefix: 'Receipts — Money Code',
        filesField: 'attachments',
        uploadFileType: 'Receipt',
        getFileUrl: 'moneycodes/getFile',
        addFileUrl: 'moneycodes/addFile',
        removeFileUrl: 'moneycodes/removeFile',
        entityIdParam: 'moneyCodeId',
    },
    [ATTACHMENT_ENTITY_TYPES.INSPECTION]: {
        popupKind: 'inspectionAttachments',
        titlePrefix: 'Attachments — Inspection',
        filesField: 'files',
        uploadFileType: 'Inspection',
        getFileUrl: 'inspections/getFile',
        addFileUrl: 'inspections/addFile',
        removeFileUrl: 'inspections/removeFile',
        entityIdParam: 'inspectionId',
    },
    [ATTACHMENT_ENTITY_TYPES.CITATION]: {
        popupKind: 'citationAttachments',
        titlePrefix: 'Attachments — Citation',
        filesField: 'files',
        uploadFileType: 'Citation',
        getFileUrl: 'citations/getFile',
        addFileUrl: 'citations/addFile',
        removeFileUrl: 'citations/removeFile',
        entityIdParam: 'citationId',
    },
};

export function getAttachmentEntityConfig(entityType) {
    const config = ATTACHMENT_ENTITY_CONFIG[entityType];
    if (!config) {
        throw new Error(`Unknown attachment entity type: ${entityType}`);
    }
    return config;
}

export function getEntityAttachments(entity, entityType) {
    const config = getAttachmentEntityConfig(entityType);
    return entity?.[config.filesField];
}
